/**
 * Options that modify a product and can apply changes to its price.
 */
class Option {
  constructor({ name, addedPrice } = {}) {
    this.name = name;
    this.addedPrice = addedPrice;
  }

  toMap() {
    return { name: this.name, addedPrice: this.addedPrice };
  }

  static fromMap(obj) {
    return new Option(obj);
  }
}

export default Option;
